import { Icon, useClipboard } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MdContentCopy } from 'react-icons/md'
import useToast from '../hooks/useToast'

export const CopyIcon = ({
  textToCopy,
  extraPropsForIcon,
}: {
  textToCopy: string
  extraPropsForIcon?: any
}): React.ReactElement => {
  const { t } = useTranslation()
  const toast = useToast()
  const {
    onCopy
  } = useClipboard(textToCopy)

  return (
    <Icon
      {...extraPropsForIcon}
      as={MdContentCopy}
      color="appSlate"
      onClick={() => {
        onCopy()
        toast({
          description: t('copied', 'Copied!'),
          status: 'success',
          isClosable: true,
          duration: 5000,
          position: 'top-right',
          variant: 'outline',
        })
      }}
      cursor="pointer"
    />
  )
}
